import { isNil } from 'lodash';

const displayPrice = (value) => {
  if (isNil(value) || isNil(parseFloat(value))) return null;
  return `${parseFloat(value)
    .toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .replace(/\s/, ' ')}`;
};

export default displayPrice;
